/** Electricity allocation groups /metering/fee/electricitySharing */
export default {
  electricitySharing: {
    phGroupId: 'Group ID',
    phGroupName: 'Group name',
    phShareType: 'Allocation method',
    btnSearch: 'Search',
    btnReset: 'Reset',
    btnExport: 'Export',
    listTitle: 'Electricity allocation groups',
    btnAdd: 'Add',
    sortDefault: 'Default sort',
    colId: 'Group ID',
    colName: 'Group name',
    colShareType: 'Method',
    colActions: 'Actions',
    opDetail: 'Details',
    opDelete: 'Delete',
    opDebit: 'Debit',
    emptyDesc: 'No data',
    dialogAddTitle: 'Add allocation group',
    dialogEditTitle: 'Edit allocation group',
    formName: 'Group name',
    formShareType: 'Method',
    phFormName: 'Enter group name',
    phFormShareType: 'Select method',
    btnCancel: 'Cancel',
    btnConfirm: 'OK',
    btnSubmitting: 'Submitting...',
    debitTitle: 'Group debit',
    debitFormName: 'Group name',
    debitFormId: 'Group ID',
    debitFormAmount: 'Amount',
    debitFormRemark: 'Remark',
    phAmount: 'Enter amount',
    phRemark: 'Enter remark',
    yuanSuffix: 'CNY',
    debitBtnCancel: 'Cancel',
    debitConfirm: 'Confirm debit',
    debitSubmitting: 'Processing...',
    shareTypeArea: 'By floor area',
    shareTypeEnergy: 'By energy use',
    msgFetchFail: 'Failed to load data',
    msgFetchListFail: 'Failed to load groups',
    msgExportEmpty: 'Nothing to export',
    msgExportOk: 'Exported {count} row(s)',
    msgExportFail: 'Export failed',
    confirmDeleteTitle: 'Notice',
    confirmDeleteMsg: 'Deleting removes linked tenants and meters. Continue?',
    confirmOk: 'OK',
    confirmCancel: 'Cancel',
    msgDeleteOk: 'Deleted',
    msgDeleteFail: 'Delete failed',
    confirmShareTitle: 'Notice',
    confirmShareAdd: 'Create this group?',
    confirmShareEdit: 'Save changes?',
    msgAddOk: 'Created',
    msgEditOk: 'Updated',
    msgAddFail: 'Create failed',
    msgEditFail: 'Update failed',
    msgOpFail: 'Operation failed',
    confirmDebitTitle: 'Notice',
    confirmDebitMsg: 'Confirm debit?',
    msgDebitOk: 'Debited',
    msgDebitFail: 'Debit failed',
    ruleNameRequired: 'Enter group name',
    ruleNameLen: '1–50 characters',
    ruleAmountRequired: 'Enter amount',
    ruleAmountInvalid: 'Enter a valid amount',
    ruleAmountPositive: 'Amount must be greater than 0',
    ruleAmountMax: 'Amount cannot exceed 999999.99',
    exportSheetName: 'Elec sharing',
    exportFilePrefix: 'elec_sharing_'
  }
}
